import React from "react";
import { Card, Table } from "react-bootstrap";
import moment from "moment";
import { get } from "lodash";
import { getReservationHighlightColor } from "../../helpers/reservations";
import ReservationDot from "./ReservationDot";

const DailyReservationsList = ({
  reservations,
  selectedDate,
  onReservationClick,
  RESERVATION_COLOR,
}) => {
  const dailyReservations = reservations
    .filter(
      (res) =>
        moment(res.order_date).isSame(selectedDate, "day") &&
        !res.status?.toLowerCase().includes("cancelled") &&
        !res.order_status?.toLowerCase().includes("cancelled"),
    )
    .sort((a, b) => a.order_time.localeCompare(b.order_time));

  const totalGuests = dailyReservations.reduce((acc, res) => {
    const guestCount = get(res, "order_details[0].qty", 0);
    return acc + guestCount;
  }, 0);

  return (
    <Card
      className="border-0 shadow-sm"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <style>
        {`   .bg-orange {
          background-color: #fa903e !important;
        }`}
      </style>
      <Card.Header
        className="bg-light border-0 py-4 px-6 d-flex justify-content-between align-items-center"
        style={{ borderBottom: "1px solid #ebedf3 !important" }}
      >
        <h6
          className="font-weight-boldest text-uppercase font-size-md m-0"
          style={{ letterSpacing: "1px" }}
        >
          Reservations for {moment(selectedDate).format("MMM D")}
        </h6>
        <div className="d-flex align-items-center">
          <span
            className="badge badge-light-primary font-weight-boldest mr-3"
            style={{
              backgroundColor: `${RESERVATION_COLOR}1A`,
              color: RESERVATION_COLOR,
            }}
          >
            {dailyReservations.length} Bookings
          </span>
          <span
            className="badge badge-light-info font-weight-boldest"
            style={{ backgroundColor: "#f1faff", color: "#3699FF" }}
          >
            {totalGuests} Guests
          </span>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <div
          className="table-responsive"
          style={{ maxHeight: "300px", overflowY: "auto" }}
        >
          <Table hover className="mb-0">
            <thead
              className="thead-light"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <tr>
                <th className="font-weight-bolder" style={{ width: "5%" }}></th>
                <th className="font-weight-bolder">Time</th>
                <th className="font-weight-bolder">Guest</th>
                <th className="font-weight-bolder text-center">Pax</th>
                <th className="font-weight-bolder">Table</th>
              </tr>
            </thead>
            <tbody>
              {dailyReservations.length > 0 ? (
                dailyReservations.map((res) => {
                  const guestName = `${get(
                    res,
                    "guest_customer.first_name",
                    "",
                  )} ${get(res, "guest_customer.last_name", "")}`;
                  const pax = get(res, "order_details[0].qty", "-");
                  const table = get(res, "reservation_notes.table.name", "N/A");

                  let parsedNotes = {};
                  try {
                    parsedNotes = res.notes ? JSON.parse(res.notes) : {};
                  } catch (e) {
                    // notes is not a valid JSON
                  }
                  const dietary = get(parsedNotes, "dietary", []);
                  const isPdr = res.reservation_notes?.table?.isExclusive;

                  const color = getReservationHighlightColor({
                    isVip: res.partner_identifier?.level === "VIP",
                    isPaid: res.payment?.amount > 0,
                    hasDietary: dietary.length > 0,
                    isPendingPayment:
                      res.payment?.status === "pending" ||
                      res.payment?.status === "failed",
                  });

                  return (
                    <tr
                      key={res._id}
                      onClick={() =>
                        onReservationClick && onReservationClick(res)
                      }
                      style={{ cursor: "pointer" }}
                      className="tr-hover"
                    >
                      <td className="align-middle text-center">
                        <ReservationDot color={color} isExclusive={isPdr} />
                      </td>
                      <td className="font-weight-bold align-middle">
                        {moment(res.order_time, "HH:mm").format("h:mm A")}
                      </td>
                      <td className="text-dark-75">{guestName}</td>
                      <td className="text-center font-weight-bold">{pax}</td>
                      <td className="text-muted">{table}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-5">
                    No reservations for this date.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DailyReservationsList;
